import { render, staticRenderFns } from "./CountinType.vue?vue&type=template&id=0ab17b1e"
import script from "./CountinType.vue?vue&type=script&lang=js"
export * from "./CountinType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports